import React from 'react';
import './Home.css';
import {BannerImage, BannerVideo} from './sections/Banner/Banner';
import AboutUs from './sections/AboutUs/AboutUs';
import RequestForm from '../../components/EntToEndUI/RequestForm/RequestForm';
import PageTitle from '../../components/Other/PageTitle/PageTitle';
// import Features from './sections/Features/Features';
// import Services from './sections/Services/Services';
// Импорт других секций

const Home = () => {
  return (
    <div className="home-page">

      <PageTitle title={"Главная"} />
      <BannerImage />
      <BannerVideo />
      <AboutUs />
      <RequestForm />
    </div>
  );
};

export default Home; 